export default __webpack_public_path__ + "static/lozenge-do-4-light-d3579f1ce0686c372a514c2cfddbae1b.png";